import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PolicyTooltipService } from '@services/my-insurance/policy-tooltip.service';
import { InfoTooltipComponent } from '../../../../common/info-tooltip/info-tooltip.component';
import { PaymentContext } from '../bn-payment-actions/bn-payment-actions.component';

@Component({
  selector: 'app-bn-outstanding-balance',
  templateUrl: './bn-outstanding-balance.component.html',
  styleUrls: ['./bn-outstanding-balance.component.scss'],
  imports: [CommonModule, TranslateModule, InfoTooltipComponent]
})
export class BnOutstandingBalanceComponent implements OnChanges {
  @Input() policy: any;
  @Input() context!: PaymentContext;
  @ViewChild('outstandingBalTooltip') outstandingBalTooltip?: InfoTooltipComponent;

  showRenewalAndCurrentBalance = false;
  outstandingBalTooltipContent: string | null = null;
  outstandingBalance: any = null;
  priorTermBalance = 0;
  isAcmic: boolean;
  detailedOutBalance = false;

  get isMobile(): boolean {
    return this.policyTooltipService.isMobile;
  }

  constructor(
    private acmicService: AcmicService,
    private policyTooltipService: PolicyTooltipService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['context']) {
      this.onContextChange();
    }
    if (changes['policy']?.currentValue) {
      this.onPolicyChange(changes['policy'].currentValue);
    }
  }

  private onContextChange(): void {
    this.outstandingBalance = this.context?.outstandingBalance ?? null;
  }

  private onPolicyChange(policy: any): void {
    this.priorTermBalance = policy?.priorYearBalance?.theAmount ?? 0;
    this.detailedOutBalance = (policy.hasPriorYearBalance || (this.priorTermBalance !== 0 && policy.isUnderRenewal))
                                && policy?.policynumber?.policyNumber?.length === 10;
    this.showRenewalAndCurrentBalance = false;
    this.outstandingBalTooltipContent = this.policyTooltipService.getOutstandingBalanceTooltip(policy);
  }

  toggleTooltip(event: Event, tooltip: InfoTooltipComponent): void {
    event.stopPropagation();
    tooltip.toggle();
  }

  viewOutStandingBalance(flag: boolean): void {
    this.showRenewalAndCurrentBalance = flag;
  }
}
